import cx from 'clsx';

import styles from '../../card/Card.module.css';

type CardHeaderProps = {
  extendedBorder?: boolean;
  isBorderless?: boolean;
  isClosed?: boolean;
  className?: string;
  children?: React.ReactNode;
};

export function CardHeader({ extendedBorder = false, className, children, isBorderless, isClosed }: CardHeaderProps) {
  return (
    <div
      className={cx(styles['Card-header'], className, {
        [styles['Card-header--withBorder']]: !isBorderless,
        [styles['Card-header--extendedBorder']]: extendedBorder,
        [styles['Card-header--closed']]: isClosed,
      })}
    >
      {children}
    </div>
  );
}
